import React, { useEffect,useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import AdminResendPassword from "./AdminResendPassword";
import { useNavigate } from "react-router-dom";

const AdminResendPasswordDashboard = () => {
  const navigate = useNavigate();
  const {
      isAdmin,
    } = useContext(AuthContext);

  useEffect(() => {
    if (!isAdmin) {
      navigate("/", { replace: true });
    }
  }, [isAdmin, navigate]);

  return (
    <div>
      <Navbar
      />
      <div className="mt-20 admin-container">
        <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">Resend Email</h2>
          <AdminResendPassword />
        </div>
      </div>
    </div>
  );
};

export default AdminResendPasswordDashboard;
